import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHotelsDotComComponent } from './simple-icons-hotels-dot-com.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHotelsDotComComponent ],
    exports:      [ SimpleIconsHotelsDotComComponent ],
    bootstrap:    []
})
export class SimpleIconsHotelsDotComModule {}
